import Axios from 'axios';
import { SERVER_URL } from './config';

export const http = Axios.create({
  baseURL: SERVER_URL,
});
